import {otsBaseApi} from "../../ots-api";
import {NotificationSenderProfile, NotificationSenderProfileSaveDTO} from "../../../model/notification-sender-profile";

const ALL_TAG_TYPES = [
  "NotificationSenderProfiles",
  "ObjectObjectChangeLogs",
] as const;

type TagType = typeof ALL_TAG_TYPES[number];

const taggedBaseApi = otsBaseApi.enhanceEndpoints({
  addTagTypes: ALL_TAG_TYPES
});

const notificationSenderProfileApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllNotificationSenderProfiles: builder.query<
      NotificationSenderProfile[],
      void
    >({
      query: () => ({
        url: `/notification-sender-profiles/all`,
        method: 'GET',
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "NotificationSenderProfiles", id} as const)),
            {type: "NotificationSenderProfiles", id: "LIST"}
          ];
        } else {
          return [{type: "NotificationSenderProfiles", id: "LIST"}];
        }
      },
    }),
    getNotificationSenderProfile: builder.query<NotificationSenderProfile, string>({
      query: (id) => ({
        url: `/notification-sender-profiles/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "NotificationSenderProfiles", id}]
    }),
    createNotificationSenderProfile: builder.mutation<NotificationSenderProfile, NotificationSenderProfileSaveDTO>({
      query: (mapping) => ({
        url: "/notification-sender-profiles",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [{type: "NotificationSenderProfiles", id: "LIST"}]
    }),
    updateNotificationSenderProfile: builder.mutation<NotificationSenderProfile, NotificationSenderProfileSaveDTO>({
      query: (mapping) => ({
        url: "/notification-sender-profiles",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [
        {type: "NotificationSenderProfiles", id},
        {type: "ObjectObjectChangeLogs", id}
      ]
    }),
    deleteNotificationSenderProfile: builder.mutation<void, Partial<NotificationSenderProfile>>({
      query: (mapping) => ({
        url: "/notification-sender-profiles",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [{type: "NotificationSenderProfiles", id}]
    }),
  })
});

export const {
  useGetAllNotificationSenderProfilesQuery,
  useGetNotificationSenderProfileQuery,
  useCreateNotificationSenderProfileMutation,
  useUpdateNotificationSenderProfileMutation,
  useDeleteNotificationSenderProfileMutation,
} = notificationSenderProfileApi;
